// extracted by mini-css-extract-plugin
export default {"flashingStars":"FlashingStars_flashingStars__dywxh","blink":"FlashingStars_blink__nQcK-"};